export default "__VITE_ASSET__DcXkzntP__"